<template>
  <div class="buyu">
    <activity group="buyu" :rule="rule" :range="range" />
  </div>
</template>

<script>
import Activity from './components/Activity.vue'

export default {
  components: {
    Activity
  },
  data() {
    return {
      rule: '注意：1）<font color="#FFE573">累计赚取金额</font>需达到对应门槛才能上榜；<br>2）若<font color="#FFE573">同时多人达到同一门槛</font>，根据金额高低排序发放奖励，满员则顺延至下一门槛奖励发放，以此类推；<br>3）在截榜时间内，以累计赚取金额<font color="#FFE573">由高到低依次排序</font>，发放奖励；',
      range: '试玩范围：仅限在<font color="#FFE573">【高额赚】-【捕鱼】</font>列表中所有游戏'
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .activity {
  background: #0070E7;

  .block.bg {
    background: #2790FF;
    box-shadow: 0 .02rem .08rem 0  #005ABA, inset 0 .01rem .07rem 0 #B3E8FF;

    .title.bg {
      background: url('~@/assets/images/ranking_buyu/title_bg.png') no-repeat;
      background-size: 100% 100%;
      background-position: center center;
    }
  }

  .block .content {
    box-shadow: inset 0 .01rem .08rem 0 rgba(0,112,231,0.65);
  }
  
  .banner {
    display: block;
    width: 100%;
    height: 2.2rem;
    background-image: url('~@/assets/images/ranking_buyu/banner.png');
    background-size: 3.75rem 2.2rem;
    position: relative;
    overflow: hidden;

    .periods {
      display: block;
      width: 2rem;
      height: .26rem;
      background: #1A89FF;
      margin: 0 auto;
      margin-top: 1.5rem;
      border-radius: .13rem;
      overflow: hidden;

      span:first-child {
        display: block;
        float: left;
        width: .52rem;
        height: .26rem;
        margin-right: .09rem;
        line-height: .26rem;
        font-size: .14rem;
        color: #1A89FF;
        background: #FFFFFF;
        border-radius: .13rem;
        text-align: center;
        overflow: hidden;
      }
      span:last-child {
        display: block;
        float: left;
        height: .26rem;
        font-size: .14rem;
        color: #FFFFFF;
        line-height: .26rem;
      }
    }
    .levitate {
      display: block;
      position: absolute;
      right: 0;
      top: .33rem;
      font-size: .12rem;
      overflow: hidden;

      p {
        display: block;
        width: .3rem;
        height: .68rem;
        color: #FFFFFF;
        background: rgba(26,137,255,0.7);
        writing-mode:tb-rl;
        border: .01rem solid rgba(255,255,255,0.50);
        border-radius: .08rem 0 0 .08rem;
        text-align: center;
        line-height: .3rem;
        overflow: hidden;
      }
      p:last-child {
        margin-top: .08rem;
      }
    }
  }

  .enroll {
    display: block;
    width: 100%;
    overflow: hidden;

    .button {
      display: block;
      width: 2.86rem;
      margin: .14rem auto .1rem auto;
      span {
        display: flex;
        align-items:center;
        justify-content:center;
        height: .52rem;
        font-size: .18rem;
        font-weight: bold;
        text-shadow: 0 .01rem 0 rgba(255,255,255,0.60);
        color: #9E5433;
        letter-spacing: .0225rem;
        background-image: linear-gradient(0deg, #FFB042 0%, #FFF8CB 100%);
        box-shadow: 0 .02rem .08rem 0 #004996, inset 0 .02rem .08rem 0 rgba(0,0,0,0.20), inset 0 -.04rem .08rem 0 rgba(255,255,255,0.6);
        border-radius: .27rem;
      }
    }
    .is_enroll {
      span {
        background-image: linear-gradient(0deg, #fecf2b 0%, #fcf1a4 100%);
        box-shadow: 0 .02rem .08rem 0 #004996, inset 0 .02rem .08rem 0 rgba(0,0,0,0.20), inset 0 -.04rem .08rem 0 rgba(255,255,255,0.6);
      }
    }
  }

  .rank {
    .tab {
      li.bg {
        background: #2790FF;
        box-shadow: 0 .02rem .08rem 0  #005ABA, inset 0 .01rem .07rem 0 #B3E8FF;
      }
    }
    .up.bg {
      background-image: url('~@/assets/images/ranking_buyu/up.png');
      background-size: .25rem .25rem;
    }
    .down.bg {
      background-image: url('~@/assets/images/ranking_buyu/down.png');
      background-size: .25rem .25rem;
    }
    .up.disable.bg {
      background-image: url('~@/assets/images/ranking_buyu/up_disable.png');
      background-size: .25rem .25rem;
    }
    .down.disable.bg {
      background-image: url('~@/assets/images/ranking_buyu/down_disable.png');
      background-size: .25rem .25rem;
    }
  }
}
</style>